import { useEffect, useRef } from 'react';

export const useMarketingLogSend = (type: '신청완료' | '조회완료', value: string | null | undefined) => {
  const isLogSend = useRef(true);

  useEffect(() => {
    const isTenpingSent = localStorage.getItem('TenpingSent');
    if (!!value && isLogSend.current) {
      isLogSend.current = false;
      const tenpingScript = (window as any).TenpingScript;
      if (!isTenpingSent && tenpingScript) {
        tenpingScript.SendConversion();
        localStorage.setItem('TenpingSent', new Date().toString());
      }
    }
  }, [value]);
};
